module.exports = __webpack_public_path__ + "img/reply_hover.10cbfdf5.svg";